var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-page',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"text-h4 text-decoration-underline"},[_vm._v("Contact")]),_c('p',{staticClass:"mt-10 page-info-text"},[_vm._v("Coming soon. . .")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }